import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Small UI flag (not the real auth). Real auth = httpOnly cookie set by backend.
const AUTH_FLAG = 'nagisa_auth';
export const setAuthFlag = () => sessionStorage.setItem(AUTH_FLAG, '1');
export const hasAuthFlag = () => sessionStorage.getItem(AUTH_FLAG) === '1';
export const clearAuthFlag = () => sessionStorage.removeItem(AUTH_FLAG);

// Back-compat exports (used across files; now no-ops for tokens)
export const getToken = () => (hasAuthFlag() ? '1' : '');
export const clearToken = () => clearAuthFlag();

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly cookies with every request
});

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
};

export const accountsApi = {
  list: (params = {}) => api.get('/accounts', { params }),
  get: (slug) => api.get(`/accounts/${slug}`),
  create: (data) => api.post('/accounts', data),
  update: (id, data) => api.put(`/accounts/${id}`, data),
  remove: (id) => api.delete(`/accounts/${id}`),
};

export const sellersApi = {
  list: () => api.get('/sellers'),
  create: (data) => api.post('/sellers', data),
  update: (id, data) => api.put(`/sellers/${id}`, data),
  remove: (id) => api.delete(`/sellers/${id}`),
  toggleOnline: (id, online) => api.patch(`/sellers/${id}/online?online=${online}`),
};

export const adminApi = {
  stats: () => api.get('/admin/stats'),
  seed: () => api.post('/admin/seed'),
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export default api;
